import { TeamOutlined } from "@ant-design/icons";

import { TextDOMPurify } from "Services/Sanitization";

import { escapeRegExp } from "../helper";

import styles from "./SpotlightAudienceItem.module.scss";

interface SpotlightAudienceItemProps {
    name: string;
    description: string;
    searchValue: string;
    onCallback: () => void;
    route?: string;
}

export function SpotlightAudienceItem({
    name,
    description,
    searchValue,
    onCallback,
    route,
}: SpotlightAudienceItemProps): JSX.Element {
    const highlightMatches = (text: string) => {
        // Escape special regex characters in searchValue
        const escapedSearchValue = escapeRegExp(searchValue);
        return text
            .split(new RegExp(`(${escapedSearchValue})`, "i"))
            .map((part, index) =>
                part.toLowerCase() === searchValue.toLowerCase()
                    ? `<em key=${index}>${part}</em>`
                    : `<span key=${index}>${part}</span>`
            )
            .join("");
    };

    return (
        <div className={styles.spotlightItem} data-route={route} onClick={onCallback}>
            <div>
                <TeamOutlined />
            </div>
            <div>
                <div className={styles.routeContainer}>
                    <div
                        className={styles.name}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(highlightMatches(name)),
                        }}
                    />
                </div>
                {description && (
                    <div
                        className={styles.description}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(highlightMatches(description)),
                        }}
                    />
                )}
            </div>
        </div>
    );
}
